// This class helps with parsing an entire recording that spans several days, into one-day recordings
// that start at 0:00:00 and ends at 23:59:59, except for the first and last day of a recording range
export default class TimeUtilities
{
	constructor(){}

}

